import { Box, Checkbox } from "@chakra-ui/react";
import React, { ReactNode } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { ChakraProps } from "@chakra-ui/system/dist/types/system.types";
import styled from "@emotion/styled";

import { FieldPrototype } from "./FieldPrototype";
import { RedText } from "./RedText";

interface IProps extends ChakraProps {
  name: string;
  isRequired?: boolean;
  label?: ReactNode;
}

const CheckBoxField = ({ name, isRequired, label, ...restProps }: IProps) => {
  const { setValue } = useFormContext();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked ? 1 : 0;
    setValue(name, newValue, { shouldValidate: true });
  };

  return (
    <FieldPrototype isRequired={isRequired} name={name} {...restProps}>
      {({
        methods: {
          formState: { isSubmitting },
        },
      }) => (
        <Controller
          name={name}
          render={(props) => {
            return (
              <CheckboxContainer>
                <Checkbox
                  id={`${name}-checkbox`}
                  alignItems="flex-start"
                  onChange={handleChange}
                  isChecked={props.value}
                  isDisabled={isSubmitting}
                >
                  {isRequired && <RedText d="inline">*</RedText>}
                  <Box>{label}</Box>
                </Checkbox>
              </CheckboxContainer>
            );
          }}
        />
      )}
    </FieldPrototype>
  );
};

const CheckboxContainer = styled.div`
  .chakra-checkbox__control {
    margin-top: 3px;
  }
`;

export { CheckBoxField };
